import { Row, Col, Form, Collapse, Select, Spin } from "antd";
import { PrimaryButton } from "components/common/Buttons";
import { SelectEE } from "../SelectEntreEspecies/SelectEE";
import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
import axios from "axios";
import { AlertModal } from "components/common/modals/modals";
import { AppContext } from "app/AppContext";
import { userHasPermission } from "utils/userHasPermission";
import { ENTRE_ESPECIE } from "app_permissions/noches_vacio";

const { Panel } = Collapse;
const { Option } = Select;

const FormularioEntreEspecie = ({
  configuracion,
  selected,
  isloadingInfo,
}) => {
  const [form] = Form.useForm();

  const [levels, setlevels] = useState([]);
  const [configSpecie, setconfigSpecie] = useState({});
  const [selectedLevelDesde, setSelectedLevelDesde] = useState({});
  const [loadingBySection, setLoadingBySection] = useState({});
  const requestIdRef = useRef({});

  const [isLoading, setisLoading] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({
    type: "",
    title: "",
    message: "",
  });

  const { rolData } = useContext(AppContext);
  const EDITAR = userHasPermission(rolData?.role, ENTRE_ESPECIE.EDITAR);

  const levelsSpecie = useCallback(() => {
    const filtered =
      configuracion?.LevelsSpecie?.filter(
        (lvl) => lvl.specie.code === selected && lvl.status_id !== 6
      ) || [];

    setlevels(filtered);
  }, [configuracion?.LevelsSpecie, selected]);

  // 🔥 FIX: construir payload correctamente
  const getBodyCrossSpecie = (section) => {
    const dynamicKey = Object.keys(section).find(
      (k) => !["selectedNights", "idClasificationCross"].includes(k)
    );

    if (!dynamicKey) return { crossSpecie: [], crossSpecieEdit: [] };

    const fromValue = section[dynamicKey];
    const selectedNights = section.selectedNights || {};

    const [fromLevel, fromSpecie] = String(fromValue).split("-");

    const levels_until = [];
    const levels_until_edit = [];

    Object.entries(selectedNights).forEach(([key, value]) => {
      const [untilLevel, id] = key.split("-");

      if (id !== "undefined") {
        levels_until_edit.push({
          id: Number(id),
          range_empty_night_id: value,
          until_level: Number(untilLevel),
        });
      } else {
        levels_until.push({
          range_empty_night_id: value,
          until_level: Number(untilLevel),
        });
      }
    });

    return {
      crossSpecie:
        levels_until.length > 0
          ? [
              {
                pyramid_specie_id: Number(fromSpecie),
                from_specie: Number(fromSpecie),
                until_specie: Number(dynamicKey),
                status_id: 1,
                levels: [
                  {
                    from_level: Number(fromLevel),
                    levels_until,
                  },
                ],
              },
            ]
          : [],
      crossSpecieEdit:
        levels_until_edit.length > 0
          ? [
              {
                pyramid_specie_id: Number(fromSpecie),
                from_specie: Number(fromSpecie),
                until_specie: Number(dynamicKey),
                status_id: 1,
                levels: [
                  {
                    from_level: Number(fromLevel),
                    levels_until: levels_until_edit,
                  },
                ],
              },
            ]
          : [],
    };
  };

  // 🔥 FIX: submit robusto
const handleSubmit = async (values) => {
  const sections = values?.sections || [];
  setisLoading(true);

  let hasSuccess = false;
  let hasError = false;

  try {
    for (const section of sections) {
      if (!section?.selectedNights) continue;

      const body = getBodyCrossSpecie(section);
      const id = section.idClasificationCross ?? section.id;

      if (body.crossSpecie.length > 0) {
        try {
          const response = await axios.post(
            process.env.REACT_APP_BASE_URL_EMPTY_NIGHT + "/cross-specie/",
            { cross_specie: body.crossSpecie },
            {
              validateStatus: (status) => status >= 200 && status < 300,
            }
          );

          if (response?.status === 200 || response?.status === 201) {
            hasSuccess = true;
          } else {
            hasError = true;
          }
        } catch (error) {
          console.error("POST error", error);
          hasError = true;
        }
      }

      if (body.crossSpecieEdit.length > 0) {
        try {
          const response = await axios.patch(
            process.env.REACT_APP_BASE_URL_EMPTY_NIGHT +
              "/cross-specie/" +
              id,
            { cross_specie: body.crossSpecieEdit },
            {
              validateStatus: (status) => status >= 200 && status < 300,
            }
          );

          if (response?.status === 200 || response?.status === 201) {
            hasSuccess = true;
          } else {
            hasError = true;
          }
        } catch (error) {
          console.error("PATCH error", error);
          hasError = true;
        }
      }
    }

    if (hasSuccess && !hasError) {
      setModalInfo({
        type: "success",
        title: "Actualizado",
        message: "El formulario ha sido actualizado correctamente",
      });

      form.resetFields();
      setconfigSpecie({});
      setSelectedLevelDesde({});
    } else if (hasSuccess && hasError) {
      setModalInfo({
        type: "warning",
        title: "Actualización parcial",
        message: "Parte de la información fue guardada, pero algunas operaciones fallaron",
      });
    } else {
      setModalInfo({
        type: "error",
        title: "Error",
        message: "No se pudo guardar la configuración",
      });
    }
  } catch (error) {
    console.error("handleSubmit error", error);

    setModalInfo({
      type: "error",
      title: "Error",
      message: "Ocurrió un problema al guardar la configuración",
    });
  } finally {
    setisLoading(false);
    setshowModal(true);
  }
};

  // 🔥 FIX: cambio de nivel
  const handleChange = async (value, sectionId) => {
    const [niv, , conf] = value.split("-");

    const requestId = (requestIdRef.current[sectionId] || 0) + 1;
    requestIdRef.current[sectionId] = requestId;

    setSelectedLevelDesde((prev) => ({
      ...prev,
      [sectionId]: value,
    }));

    setconfigSpecie((prev) => ({
      ...prev,
      [sectionId]: [],
    }));

    setLoadingBySection((prev) => ({
      ...prev,
      [sectionId]: true,
    }));

    try {
      const res = await axios.get(
        process.env.REACT_APP_BASE_URL_EMPTY_NIGHT +
          `/cross-specie/from-level?from_level=${niv}&cross_specie_id=${conf}`
      );

      if (requestIdRef.current[sectionId] !== requestId) return;

      setconfigSpecie((prev) => ({
        ...prev,
        [sectionId]: res.data?.list || [],
      }));
    } catch {
      setconfigSpecie((prev) => ({
        ...prev,
        [sectionId]: [],
      }));
    } finally {
      setLoadingBySection((prev) => ({
        ...prev,
        [sectionId]: false,
      }));
    }
  };

  const configBySpecie =
    configuracion?.SpecieConfig?.list?.filter(
      (c) => c.fromSpecie && c.untilSpecie
    ) || [];

  useEffect(() => {
    levelsSpecie();
    form.resetFields();
    setconfigSpecie({});
    setSelectedLevelDesde({});
    requestIdRef.current = {};
  }, [levelsSpecie, selected]);

  if (isloadingInfo) return <Spin />;

  return (
    <>
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.List name="sections" initialValue={configBySpecie}>
          {(fields) => (
            <Collapse>
              {fields.map((field) => {
                const section = configBySpecie[field.key];
                const sectionId = section?.id;

                return (
                  <Panel
                    header={`${section?.fromSpecie?.name_specie} a ${section?.untilSpecie?.name_specie}`}
                    key={sectionId}
                  >
                    <Form.Item
                      name={[field.name, section?.untilSpecie.id]}
                      label="Nivel origen"
                      rules={[{ required: true }]}
                    >
                      <Select
                        onChange={(v) => handleChange(v, sectionId)}
                        value={selectedLevelDesde[sectionId]}
                      >
                        {levels.map((lvl) => (
                          <Option
                            key={lvl.id}
                            value={`${lvl.id}-${section.fromSpecie.id}-${section.id}`}
                          >
                            {lvl.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <SelectEE
                      form={form}
                      fieldKey={field.key}
                      until={section?.untilSpecie?.code}
                      emptyNights={configuracion.DataMaster}
                      configuracion={configuracion}
                      configSpecie={configSpecie[sectionId] || []}
                      selectedLevelDesde={selectedLevelDesde[sectionId]}
                      specieId={section?.id}
                      untilSpecieId={section?.untilSpecie.id}
                      isloadingInfoDataBase={loadingBySection[sectionId]}
                    />
                  </Panel>
                );
              })}
            </Collapse>
          )}
        </Form.List>

        {EDITAR && (
          <PrimaryButton type="submit" isLoading={isLoading}>
            Guardar
          </PrimaryButton>
        )}
      </Form>

      <AlertModal
        show={showModal}
        onClose={() => setshowModal(false)}
        title={modalInfo.title}
        type={modalInfo.type}
      >
        {modalInfo.message}
      </AlertModal>
    </>
  );
};

export default FormularioEntreEspecie;